import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-footer-links',
  templateUrl: './footer-links.component.html',
  styleUrl: './footer-links.component.scss',
  imports: [RouterLink],
})
export class FooterLinksComponent {

    links = [
        { title: 'Outline of responsibilities', routerLink: '/documents/outline', url: null, target: null },
        { title: 'Privacy', routerLink: '/documents/privacy', url: null, target: null },
    ];
}
